export const PUBLICATION_REQUEST = 'PUBLICATION_REQUEST';
export const PUBLICATION_SUCCESS = 'PUBLICATION_SUCCESS';
export const PUBLICATION_FAIL    = 'PUBLICATION_FAIL';

